import { Component, OnInit, Input } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AccountStatusService } from '../../services/accountstatus.service';
import * as moment from 'moment';
import { ActivatedRoute, Router} from '@angular/router';

import { SectionEditComponent } from '../section-edit/section-edit.component';

// JSON definitions of the edit forms
import AccountStatusEdit from '../architecture-edit-accountstatus.json';
import AccountStatusNewEdit from '../architecture-edit-accountstatus-new.json';

@Component({
  selector: 'app-sl-use-cases',
  templateUrl: './sl-use-cases.component.html',
  styleUrls: ['./sl-use-cases.component.scss']
})
export class SlUseCasesComponent implements OnInit {

  @Input() showEditable=false;
  @Input() accountsStatusData;
  @Input() sAccount;
  @Input() sVersion;
  @Input() width="1650px";
  @Input() useNewLayout = false;

  public eventNums = [];

  constructor(
    public acountsStatusService: AccountStatusService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.eventNums = this.getEventRows();
  }

  openStatusEdit(section){

    if(!this.showEditable) return false;

    const jsonData = this.useNewLayout ? AccountStatusNewEdit : AccountStatusEdit

    jsonData.sections.forEach(item => {
      if(item.title == "Events"){
        item.fields[0]["fields"] = [];
        if(this.eventNums.length>0){
          this.eventNums.forEach(num => {
            let temp=[];
            temp.push({"name":"ev_date_"+num,"type":"date","readonly":true,label:"Date",isRequired:true});
            temp.push({"name":"ev_title_"+num,"type":"formattedtext","readonly":true,label:"Title",isRequired:true});
            temp.push({"name":"ev_desc_"+num,"type":"formattedtext","readonly":true,label:"Description"});
            temp.push({"name":"ev_contributor_"+num,"type":"string","readonly":true,label:"Contributor"});
            item.fields[0]["fields"].push(temp);
          });
        }
      }else if(item.title == "Top Section"){
        if(!this.sAccount.isdeliverylead){
          let newFields = [];
          item.fields.forEach( x => {
            if(x.name !== "pl"){
              newFields.push(x);
            }
          });
          item.fields = newFields;
        }
      }
    });
    
    let data = {
      sectionDef: this.useNewLayout ? AccountStatusNewEdit : AccountStatusEdit,
      data: this.accountsStatusData,
      account: this.sAccount,
      versionid: this.sVersion,
      selectTab: section
    }

    let newdata = this.deepCopy(data);

    let dialogRef = this.dialog.open(SectionEditComponent, {
      id: "SectionEditDialog",
      height: '600px',
      width: '700px',
      data: newdata
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result=="cancel"){
      
      } else if(result!=undefined){

        // save to the database
        this.updateStatusData(result)
        
      }
    })  
  }


  updateStatusData(data) {
    let uData = [];
    Object.keys(data).forEach(x => {
      let drow = data[x];

      if (drow["newtext"] !== undefined) {
        let newtext = (drow["newtext"] == null ? "" : drow["newtext"].trim());
        let oldtext = (drow["propertytext"] == null ? "" : drow["propertytext"].trim());
        if (newtext != oldtext) {
          uData.push({
            "id": drow["id"],
            "accountid": drow["accountid"],
            "versionid": drow["versionid"],
            "propertyname": x,
            "propertytext": newtext
          })
        }
      }
    });
    this.acountsStatusService.updateStatus(uData);
  }

    // deep copy of Object
    private deepCopy(obj) {
      return Object.keys(obj).reduce((v, d) => Object.assign(v, {
        [d]: obj[d]== null ? null : (obj[d].constructor === Object) ? this.deepCopy(obj[d]) : obj[d]
      }), {});
    }

    getASValue(prop){    
      if(this.accountsStatusData[prop]) {
        return this.accountsStatusData[prop]["propertytext"];
      } else {
        return "";
      }
    }
  
    // 
    getStatusRows(){
      // work out how many rows of status things there are - have 5 as the default number
      let rows = 5;
      Object.keys(this.accountsStatusData).forEach(x => {
  
          let tmpnm = "";
          if(x.startsWith("cv_")) tmpnm = x.replace("cv_","");
          if(x.startsWith("pitch_")) tmpnm = x.replace("pitch_","");
          if(x.startsWith("nextsteps_")) tmpnm = x.replace("nextsteps_","");
          if(x.startsWith("owner_")) tmpnm = x.replace("owner_","");
  
          if(this.stringIsNumber(tmpnm)){
            rows = Math.max(+tmpnm,rows);
          }
      })
    
      let rtn = [];
      for(var i=1;i<=rows;i++){
        rtn.push(i);
      }
  
      return rtn;
    }

    getEventRows(){
      // work out how many rows of status things there are - have 5 as the default number
      let rtn = [];
      Object.keys(this.accountsStatusData).forEach(x => {
          let tmpnm = "";
          if(x.startsWith("ev_title_")){
            tmpnm = x.replace("ev_title_","");
            if(this.stringIsNumber(tmpnm)&&!this.isInArray(rtn,parseFloat(tmpnm))){
              rtn.push(parseFloat(tmpnm));
            }
          };
          if(x.startsWith("ev_desc_")){
            tmpnm = x.replace("ev_desc_","");
            if(this.stringIsNumber(tmpnm)&&!this.isInArray(rtn,parseFloat(tmpnm))){
              rtn.push(parseFloat(tmpnm));
            }
          };
          if(x.startsWith("ev_date_")){
            tmpnm = x.replace("ev_date_","");
            if(this.stringIsNumber(tmpnm)&&!this.isInArray(rtn,parseFloat(tmpnm))){
              rtn.push(parseFloat(tmpnm));
            }
          };
          if(x.startsWith("ev_contributor_")){
            tmpnm = x.replace("ev_contributor_","");
            if(this.stringIsNumber(tmpnm)&&!this.isInArray(rtn,parseFloat(tmpnm))){
              rtn.push(parseFloat(tmpnm));
            }
          };
      })
      if(rtn.length>0){
        rtn.sort(function(a, b){return a - b}); 
      }
      return rtn;
    }

    stringIsNumber(s) {
      return !isNaN(parseFloat(s)) && !isNaN(s - 0)
    }

    isInArray(arr,value){
      for(var i = 0; i < arr.length; i++){
          if(value === arr[i]){
              return true;
          }
      }
      return false;
    }

    formatDate(date){
      return moment(new Date(date)).format("DD/MMM/YYYY");
    }

    redirect(accountid) {
      let o = {};    
      o['a'] = accountid;
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: o,
        queryParamsHandling: 'merge',
        skipLocationChange: false,
        replaceUrl: false
      });
    }

}


